import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { toast } from 'react-toastify';
import header from '../../assets/icm-header.jpg';
import { getBase64PDFImage } from '../../util/utils';
import {
  getPdfBase64,
  enviarArquivo,
  normalizeWhatsappPhone,
} from '../../services/pdfWhatsapp';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const abrirJanelaPdf = () => {
  try {
    return window.open('', '_blank');
  } catch (error) {
    return null;
  }
};

const publicarPdf = (docDefinition, janela, prontuario) => {
  const pdf = pdfMake.createPdf(docDefinition);

  if (janela) {
    pdf.open({}, janela);
    return;
  }

  pdf.download(
    `Prontuario-${
      prontuario && prontuario.codconsulta ? prontuario.codconsulta : 'laudo'
    }.pdf`
  );
  toast.warn('O navegador bloqueou a nova aba. O PDF foi baixado.');
};

export default async function generateProntuarioPDF(prontuario, tipo) {
  const imprimir = tipo === 'imprimirNormal' || tipo === 'imprimirTimbrado';
  const janela = imprimir ? abrirJanelaPdf() : null;

  try {
    return await emitirProntuarioPDF(prontuario, tipo, janela);
  } catch (error) {
    if (janela && !janela.closed) janela.close();
    throw error;
  }
}

async function emitirProntuarioPDF(prontuario, tipo, janela) {
  const headerImage =
    tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
      ? await getBase64PDFImage(header)
      : null;
  const paciente = prontuario.atual;
  const content = [];

  content.push({
    text: 'PRONTUÁRIO ELETRÔNICO',
    style: 'title',
    alignment: 'center',
    margin: [0, 0, 0, 10],
  });

  // Cabeçalho com retângulo preto
  content.push({
    table: {
      widths: ['*'],
      body: [
        [
          {
            stack: [
              {
                columns: [
                  {
                    text: `Nome do Paciente: ${paciente.CODPAC ||
                      ''} - ${paciente.NOMEPAC || ''}`,
                    width: '100%',
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 5],
              },
              {
                columns: [
                  {
                    text: `Data Nasc: ${paciente.dataNasc || ''}`,
                    width: '50%',
                  },
                  {
                    text: `Sexo: ${paciente.SEXOPAC || ''}`,
                    width: '20%',
                  },
                  {
                    text: `Idade: ${paciente.idadePAC || ''} anos`,
                    width: '30%',
                  },
                ],
                margin: [0, 0, 0, 5],
              },
              {
                columns: [
                  {
                    text: `Convênio: ${prontuario.convenio || ''}`,
                    width: '50%',
                  },
                  {
                    text: `Procedimento: ${prontuario.procedimento || ''}`,
                    width: '50%',
                  },
                ],
                margin: [0, 0, 0, 5],
              },
              {
                columns: [
                  {
                    text: `Código: ${prontuario.codconsulta || ''}`,
                    width: '50%',
                  },
                  {
                    text: `Data: ${prontuario.dataFormatada || ''}`,
                    width: '50%',
                  },
                ],
                margin: [0, 0, 0, 5],
              },
              {
                columns: [
                  {
                    text: `Médico que Realizou: ${prontuario.realizou || ''}`,
                    width: '100%',
                  },
                ],
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [10, 5, 10, 5],
          },
        ],
      ],
    },
    layout: {
      hLineWidth: () => 1,
      vLineWidth: () => 1,
      hLineColor: () => 'black',
      vLineColor: () => 'black',
    },
    margin: [0, 10, 0, 10],
  });

  content.push({ text: '\n' });

  // Queixa Principal e História
  if (prontuario.queixas) {
    content.push({
      text: [
        { text: 'QUEIXA PRINCIPAL E HISTÓRIA\n', bold: true, fontSize: 12 },
        { text: prontuario.queixas || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Medicações em Uso
  if (prontuario.medicamentos) {
    content.push({
      text: [
        { text: 'MEDICAÇÕES EM USO\n', bold: true, fontSize: 12 },
        { text: prontuario.medicamentos || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Hábitos
  if (prontuario.habitos) {
    content.push({
      text: [
        { text: 'HÁBITOS\n', bold: true, fontSize: 12 },
        { text: prontuario.habitos || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // ISDA
  if (prontuario.isda) {
    content.push({
      text: [
        { text: 'ISDA\n', bold: true, fontSize: 12 },
        { text: prontuario.isda || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Antecedentes Pessoais
  if (prontuario.pessoais) {
    content.push({
      text: [
        { text: 'ANTECEDENTES PESSOAIS\n', bold: true, fontSize: 12 },
        { text: prontuario.pessoais || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Antecedentes Familiares
  if (prontuario.familiares) {
    content.push({
      text: [
        { text: 'ANTECEDENTES FAMILIARES\n', bold: true, fontSize: 12 },
        { text: prontuario.familiares || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Exames Complementares
  if (prontuario.complementares) {
    content.push({
      text: [
        { text: 'EXAMES COMPLEMENTARES\n', bold: true, fontSize: 12 },
        { text: prontuario.complementares || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Exame Físico
  if (prontuario.fisico) {
    content.push({
      text: [
        { text: 'EXAME FÍSICO\n', bold: true, fontSize: 12 },
        { text: prontuario.fisico || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Hipótese Diagnóstica
  if (prontuario.hipotese) {
    content.push({
      text: [
        { text: 'HIPÓTESE DIAGNÓSTICA\n', bold: true, fontSize: 12 },
        { text: prontuario.hipotese || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Conduta
  if (prontuario.conduta) {
    content.push({
      text: [
        { text: 'CONDUTA\n', bold: true, fontSize: 12 },
        { text: prontuario.conduta || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // Observações
  if (prontuario.obs || prontuario.observacao) {
    content.push({
      text: [
        { text: 'OBSERVAÇÕES\n', bold: true, fontSize: 12 },
        { text: prontuario.obs || prontuario.observacao || '', fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 10],
    });
  }

  // CID e Peso
  const cidPesoInfo = [];
  if (prontuario.cid) cidPesoInfo.push(`CID: ${prontuario.cid}`);
  if (prontuario.cid2) cidPesoInfo.push(`CID2: ${prontuario.cid2}`);
  if (prontuario.cid3) cidPesoInfo.push(`CID3: ${prontuario.cid3}`);
  if (prontuario.peso) cidPesoInfo.push(`Peso: ${prontuario.peso} kg`);

  if (cidPesoInfo.length > 0) {
    content.push({
      text: [
        { text: 'INFORMAÇÕES ADICIONAIS\n', bold: true, fontSize: 12 },
        { text: cidPesoInfo.join(' | '), fontSize: 11 },
      ],
      style: 'content',
      margin: [0, 0, 0, 15],
    });
  }

  // Assinatura
  content.push({
    table: {
      widths: ['*'],
      body: [
        [
          {
            stack: [
              {
                text: `Conferido e assinado eletronicamente por: ${prontuario.realizou ||
                  ''}`,
                italics: true,
                alignment: 'center',
                margin: [0, 0, 0, 3],
              },
              // {
              //   text: `${prontuario.realizou || ''}`,
              //   bold: true,
              //   alignment: 'center',
              //   margin: [0, 0, 0, 3],
              // },
              {
                text: `CRM: ${paciente.CRMMED || ''} - RQE: ${paciente.RQE ||
                  ''}`,
                bold: true,
                fontSize: 10,
                alignment: 'center',
                margin: [0, 0, 0, 3],
              },
              {
                text: `Assinatura Digital: ${prontuario.HASH || ''}`,
                italics: true,
                fontSize: 9,
                alignment: 'center',
                margin: [0, 2, 0, 4],
              },
              {
                text: [
                  { text: 'Emitido em: ', bold: true },
                  `${new Date().toLocaleString('pt-BR')}\n`,
                  { text: 'ICM - Instituto do Coração de Marília', bold: true },
                ],
                fontSize: 9,
                color: '#444',
                alignment: 'center',
                margin: [0, 5, 0, 0],
              },
            ],
            margin: [10, 8, 10, 8],
          },
        ],
      ],
    },
    layout: {
      hLineWidth: () => 0.5,
      vLineWidth: () => 0.5,
      hLineColor: '#999',
      vLineColor: '#999',
      paddingLeft: () => 5,
      paddingRight: () => 5,
      paddingTop: () => 5,
      paddingBottom: () => 5,
    },
    margin: [0, 10, 0, 0],
  });

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: headerImage ? [40, 140, 40, 60] : [40, 60, 40, 60],
    footer: (currentPage, pageCount) => {
      return {
        columns: [
          {
            text: `Página ${currentPage} de ${pageCount}`,
            alignment: 'center',
            fontSize: 10,
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },
    content,
    styles: {
      title: {
        fontSize: 18,
        bold: true,
        alignment: 'center',
        margin: [0, 5],
      },
      content: { fontSize: 11, lineHeight: 1.3 },
    },
  };

  // Adiciona header apenas quando houver imagem
  if (headerImage) {
    docDefinition.header = {
      image: headerImage,
      width: 550,
      alignment: 'center',
      margin: [0, 10, 0, 10],
    };
  }

  if (tipo === 'imprimirNormal' || tipo === 'imprimirTimbrado') {
    publicarPdf(docDefinition, janela, prontuario);
  } else {
    const celular = normalizeWhatsappPhone(paciente && paciente.CELULARPAC);

    if (!celular) {
      toast.warn('Número de celular não encontrado!');
      return;
    }
    const pdfGenerator = pdfMake.createPdf(docDefinition);
    const pdfBase64 = await getPdfBase64(pdfGenerator);
    await enviarArquivo({
      to: celular,
      pdfBase64,
      paciente: {
        id: paciente && paciente.CODPAC ? paciente.CODPAC : '',
        nome: paciente && paciente.NOMEPAC ? paciente.NOMEPAC : '',
        medico: prontuario && prontuario.realizou ? prontuario.realizou : '',
      },
      codLaudo:
        prontuario && prontuario.codconsulta ? prontuario.codconsulta : '',
      fileName: `Prontuario-${
        prontuario && prontuario.codconsulta ? prontuario.codconsulta : ''
      }.pdf`,
      caption: `Olá ${paciente && paciente.NOMEPAC ? paciente.NOMEPAC : ''},
segue em anexo o seu *Prontuário Eletrônico*.

Qualquer dúvida, nossa equipe estará à disposição no setor de atendimento pelo WhatsApp 14-3402-5252\n
ICM - Instituto do Coração de Marília`,
      officialConfig: {
        procedimento: 'prontuario',
        documentTitle: 'Prontuário Eletrônico',
      },
    });
  }

  return docDefinition;
}
